import { createContext, useContext } from 'react';

import { EvaluationContextFieldOverrideFragment } from '@spotify/confidence-graphql';

import { useEvaluationContextFieldOverrides } from '../../hooks';

interface ContextValue {
  fields: EvaluationContextFieldOverrideFragment[];
}

const EvaluationContextFieldsContext = createContext<ContextValue>({
  fields: [],
});

export const EvaluationContextFieldsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // FIXME: load all, not just first page.
  const { evaluationContextFieldOverrides } =
    useEvaluationContextFieldOverrides({
      pageSize: 100,
    });

  const fields = evaluationContextFieldOverrides ?? [];

  return (
    <EvaluationContextFieldsContext.Provider value={{ fields }}>
      {children}
    </EvaluationContextFieldsContext.Provider>
  );
};

export const useEvaluationContextField = (field: string) => {
  const { fields } = useContext(EvaluationContextFieldsContext);
  return fields.find(f => f.field === field);
};
